import { useQuery } from '@tanstack/react-query';
import { supabasePublic } from '@/integrations/supabase/publicClient';
import { TimeSlot } from '@/lib/timeSlotUtils';
import { normalizeTimeForUI } from '@/lib/timeFormatUtils';

export function timeSlotsQueryKey(establishmentId: string | null) {
  return ['time-slots', establishmentId] as const;
}

export function useTimeSlotsQuery(establishmentId: string | null) {
  return useQuery({
    queryKey: timeSlotsQueryKey(establishmentId),
    queryFn: async (): Promise<TimeSlot[]> => {
      let query = supabasePublic
        .from('time_slots')
        .select('id, start_time, end_time, available_days, duration_override_minutes')
        .eq('is_active', true)
        .order('start_time');
      if (establishmentId) query = query.eq('establishment_id', establishmentId);

      const { data, error } = await query;
      if (error) throw error;

      return (data || []).map((ts: any) => ({
        id: ts.id,
        start: normalizeTimeForUI(ts.start_time),
        end: normalizeTimeForUI(ts.end_time),
        availableDays: ts.available_days,
        durationOverrideMinutes: ts.duration_override_minutes ?? null,
      }));
    },
    enabled: Boolean(establishmentId),
    staleTime: 1000 * 60 * 5,
  });
}
